module.exports = __webpack_public_path__ + "static/img/Payne-Haas.facedb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Payne-Haas.jpg
// module id = ugiJ
// module chunks = 0